import Client from 'shopify-buy'

export const shopifyBuyClient = Client.buildClient({
  domain: process.env.NEXT_PUBLIC_SHOPIFY_SHOP as string,
  storefrontAccessToken: process.env.NEXT_PUBLIC_SHOPIFY_TOKEN as string,
})
export * from './utils'
export * from './checkout'
